import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators'

import {
  getGeneralSettingsError,
  getGeneralSettingsSuccess,
  updateGeneralSettingsError,
  updateGeneralSettingsSuccess,
  updPasswordError,
  updPasswordSuccess,
} from './actions'
import {
  GENERAL_SETTINGS_REQUEST_ASYNC,
  UPDATE_GENERAL_SETTINGS_REQUEST,
  UPDATE_PASSWORD_REQUEST,
} from './constants'

const getGeneralSettingsEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(GENERAL_SETTINGS_REQUEST_ASYNC.INITIATE, UPDATE_GENERAL_SETTINGS_REQUEST.SUCCESS),
    mergeMap(() =>
      api.settings.getProfileSettings().pipe(
        map((response) => getGeneralSettingsSuccess(response)),
        catchError((error) => of(epicsErrorHandler(getGeneralSettingsError, error))),
        takeUntil(action$.pipe(ofType(GENERAL_SETTINGS_REQUEST_ASYNC.CANCEL)))
      )
    )
  )

const updateGeneralSettingsEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(UPDATE_GENERAL_SETTINGS_REQUEST.INITIATE),
    mergeMap(() =>
      api.settings.updateProfileSettings(state$.value.form.ProfileSettingsForm.values).pipe(
        map((response) => updateGeneralSettingsSuccess(response)),
        catchError((error) => of(epicsErrorHandler(updateGeneralSettingsError, error))),
        takeUntil(action$.pipe(ofType(UPDATE_GENERAL_SETTINGS_REQUEST.CANCEL)))
      )
    )
  )

const updPasswordEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(UPDATE_PASSWORD_REQUEST.INITIATE),
    mergeMap(() =>
      api.settings.updPassword(state$.value.form.PasswordForm.values).pipe(
        map((response) => updPasswordSuccess(response)),
        catchError((error) => of(epicsErrorHandler(updPasswordError, error))),
        takeUntil(action$.pipe(ofType(UPDATE_PASSWORD_REQUEST.CANCEL)))
      )
    )
  )

export default combineEpics(getGeneralSettingsEpic, updateGeneralSettingsEpic, updPasswordEpic)
